import React from 'react';
import { getOne, deleteOne } from 'api/facilityeiaApi';
import Message from 'rc-message';
// import * as _ from 'lodash';
import { Icon, Intent } from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';
import styled from 'styled-components';
import Clearfix from 'components/elements/clearfix';
import Confirm from 'components/elements/confirm-element';
import { Link } from 'react-router-dom';
import slug from 'constants/slug';
import { withRouter } from 'react-router-dom';
import { COLOR, DATETIME_FORMAT, DATE_FORMAT } from 'config';
import { connect } from 'react-redux';
import moment from 'moment';
import AttachmentContainer from 'containers/AttachmentContainer';
import {
  getList as getFacAttachList,
  deleteOne as deleteAttach,
  create as createFacAttach,
} from 'api/eiaatachmentApi';
import { getLookupTypeEiaAttachment } from 'api/lookuplistitemApi';
import PageLockHOC from 'hoc/pageLock';
import Permissions from 'react-redux-permissions';
import DisplayField from 'components/elements/display-field';

const HeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

const NameContainer = styled.div`
  color: ${COLOR.SECOND_COLOR};
  text-decoration: underline;
`;

@PageLockHOC(['facilityeia.view'])
@connect(
  (state) => ({
    menuSelected_2: state.menu.menuSelected_2,
    focusFacility: state.menu.focusFacility,
  }),
  {}
)
class FacilityeiaView extends React.Component {
  static propTypes = {};

  state = {
    _idObject: '',
    isLoaded: false,
    isLoading: false,
    facility: {},
    facilityId: '',
    initialValue: null,
  };

  async checkValidate() {
    const _id = _.result(this.props, 'match.params._id');
    if (_id) {
      const res = await getOne(_id);
      if (res.success) {
        this.setState({
          _idObject: res.data._id,
          facility: res.data.facility,
          facilityId: res.data.facility._id,
          isLoading: false,
          isLoaded: true,
          initialValue: res.data,
        });
      }
    } else {
      //this.props.history.push(slug.CO_SO.LIST);
    }
  }

  getInitialValue = (keyPath, defaultValue = '') => {
    return _.result(this.state.initialValue, keyPath, defaultValue);
  };

  getInitialDateValue = (keyPath, isDate, defaultValue = '') => {
    let value = _.result(this.state.initialValue, keyPath, defaultValue);
    if (!value) return '';
    if (isDate) return moment(value).format(DATE_FORMAT);
    return moment(value).format(DATETIME_FORMAT);
  };

  handelDelete = () => {
    if (this.ConfirmElm && this.ConfirmElm.showConfirm) {
      this.ConfirmElm.showConfirm({
        content: (
          <div>
            {`Bạn có muốn xóa tên hồ sơ: `}{' '}
            <b> {this.getInitialValue('Title')}</b>
          </div>
        ),
        cb: async (value) => {
          if (value) {
            const res = await deleteOne(this.getInitialValue('_id'));
            if (res.success) {
              Message.success({ content: 'Thành Công' });
              this.props.history.push(
                slug.CO_SO.VIEW_WITH_ID + this.state.facilityId
              );
            }
            if (res.error) Message.error({ content: res.message });
          }
        },
      });
    }
  };

  async componentWillMount() {
    await this.checkValidate();
  }

  render() {
    return (
      <div style={{ width: '100%' }}>
        <Confirm ref={(ConfirmElm) => (this.ConfirmElm = ConfirmElm)} />
        <h4
          className='bp3-heading'
          style={{
            color: COLOR.SUCCESS,
          }}
        >
          Hồ sơ môi trường
        </h4>
        <HeaderContainer>
          <div style={{ display: 'inline-flex' }}>
            <Icon
              onClick={() => {
                if (this.props.menuSelected_2) {
                  this.props.history.push(
                    `${slug.CO_SO.VIEW_WITH_ID}${this.props.focusFacility}`
                  );
                } else {
                  this.props.history.push(slug.FACILITY_EIA.LIST);
                }
              }}
              style={{ cursor: 'pointer', color: COLOR.SUCCESS }}
              icon={IconNames.CIRCLE_ARROW_LEFT}
              iconSize={Icon.SIZE_LARGE}
              intent={Intent.SUCCESS}
            />

            {this.props.focusFacility && (
              <React.Fragment>
                <Permissions allowed={[`facilityeia.write`]}>
                  <React.Fragment>
                    <Clearfix width={8} />
                    <Link
                      to={slug.FACILITY_EIA.EDIT_WITH_ID + this.state._idObject}
                    >
                      <Icon
                        style={{ cursor: 'pointer', color: COLOR.SUCCESS }}
                        icon={IconNames.MANUALLY_ENTERED_DATA}
                        iconSize={Icon.SIZE_LARGE}
                        intent={Intent.PRIMARY}
                      />
                    </Link>
                  </React.Fragment>
                </Permissions>

                <Permissions allowed={[`facilityeia.delete`]}>
                  <React.Fragment>
                    <Clearfix width={8} />
                    <Icon
                      style={{ cursor: 'pointer' }}
                      icon={IconNames.BAN_CIRCLE}
                      iconSize={Icon.SIZE_LARGE}
                      intent={Intent.DANGER}
                      onClick={this.handelDelete}
                    />
                  </React.Fragment>
                </Permissions>
              </React.Fragment>
            )}
          </div>
        </HeaderContainer>
        <Clearfix height={16} />
        <DisplayField
          isRequiredField
          label='Tên cơ sở/dự án'
          value={this.getInitialValue('facility.FacilityNameFull')}
        />
        <Clearfix height={16} />
        <DisplayField
          isRequiredField
          label='Tên hồ sơ'
          value={this.getInitialValue('Title')}
        />
        <Clearfix height={16} />
        <DisplayField
          label='Ngày phát hành'
          isRequiredField
          value={this.getInitialDateValue('DateIssued', true)}
        />
        <Clearfix height={16} />
        <DisplayField
          label='Số quyết định'
          value={this.getInitialValue('DecisionNumber')}
        />
        <Clearfix height={16} />
        <DisplayField
          label='Cơ quan cấp'
          value={this.getInitialValue('IssuingAgency')}
        />
        <Clearfix height={16} />
        <DisplayField
          label='Đường dẫn (URL)'
          value={
            <a href={`${this.getInitialValue('EIAURL')}`} target='_blank'>
              <NameContainer>{this.getInitialValue('EIAURL')}</NameContainer>
            </a>
          }
        />
        <Clearfix height={16} />
        <DisplayField label='Ghi chú' value={this.getInitialValue('Remarks')} />
        <Clearfix height={16} />
        <DisplayField
          label='Thêm vào'
          value={`${this.getInitialValue('AddedOn')
            ? moment(this.getInitialValue('AddedOn')).format(
              DATETIME_FORMAT
            ) +
            ' bởi ' +
            this.getInitialValue('AddedBy')
            : ''
            } `}
        />
        <Clearfix height={16} />
        <DisplayField
          label='Cập nhật lần cuối'
          value={`${this.getInitialValue('UpdatedOn')
            ? moment(this.getInitialValue('UpdatedOn')).format(
              DATETIME_FORMAT
            ) +
            ' bởi ' +
            this.getInitialValue('UpdatedBy')
            : ''
            } `}
        />

        <Clearfix height={8} />
        {this.state.isLoaded && (
          <AttachmentContainer
            facility={this.state.initialValue}
            hideButtonAction={this.props.focusFacility ? false : true}
            getListFunc={(query) => {
              return getFacAttachList({
                ...query,
                facilityeia: this.state._idObject,
              });
            }}
            createOne={(values) => {
              values.facilityeia = this.state._idObject;
              return createFacAttach(_.pickBy(values, _.identity));
            }}
            deleteOne={deleteAttach}
            getAttachmentTypeList={getLookupTypeEiaAttachment}
            moduleName='facilityeia'
          />
        )}
      </div>
    );
  }
}

export default withRouter(FacilityeiaView);



// WEBPACK FOOTER //
// ./src/containers/FacilityeiaContainer/FacilityeiaView/index.js